<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' [ngClass]="{'loading':pending}">
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px' (click)="goBack()" class="link">
                <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div>
                <div class='equipment-id'>
					<!-- Title -->
                    <h2 class="ui primary header">2021-2022</h2>
                </div>
            </div>

              <div fxLayout='row' fxLayoutGap='15px'>

					<button class="ui basic small  primary  button" (click)="delete()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="delete cycle">
						Delete
						</button>

					<button (click)="editProcurement()" class="ui small  primary  button" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="edit cycle">
						Edit
						</button>
					</div>

		</div>
		<div class="ui divider" appMargin marginY="3"></div>

    <div *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    </div>

		<div fxLayout="row" fxLayoutGap='50px'>
			<div fxFlex="30%">
				<div class="ui form side-panel"  appPadding="15px">
					  <div class="field" appMargin marginB="10">
						<label>DATE CREATED</label>
					17 Oct, 2020
                    </div>
                    		<div class="field" appMargin marginB="10">
						<label>CREATED BY</label>
					Tife Balogun
                    </div>
                    		<div class="field " appMargin marginB="10">
						<label>LAST EDITED</label>
						8 Sep, 2020
                    </div>
                    <div class="field" appMargin marginB="10">
						<label>EDITED BY</label>
					Kelechi Nwosu
					</div>
				</div>
				</div>
				<div fxFlex="grow">
					<div fxLayout="row" fxLayoutAlign='space-between center'>
						<h3 appMargin marginB="0">Procurement Cycle Details</h3>
						<!-- <button class="ui tiny button" >
							<i class="plus icon"></i>
							</button> -->
						</div>
						<hr>
								<div class="ui vertical basic segment">

								<div fxLayout="row">
									<div fxFlex="40%"><strong>Description</strong></div>
									<div fxFlex="grow">Procurement for the year 2020-2022</div>
								</div>
								<div class="ui divider"></div>

									<div fxLayout="row">
									<div fxFlex="40%"><strong>Project Count </strong></div>
									<div fxFlex="grow">398</div>
								</div>
								<div class="ui divider"></div>


									<div fxLayout="row">
									<div fxFlex="40%"><strong>Total Amount</strong></div>
									<div fxFlex="grow">N2,892,794,660</div>
								</div>
								<div class="ui divider"></div>


									<div fxLayout="row">
									<div fxFlex="40%"><strong>Start Date</strong></div>
									<div fxFlex="grow">22 Oct, 2020</div>
								</div>
								<div class="ui divider"></div>

									<div fxLayout="row">
									<div fxFlex="40%"><strong>End Date</strong></div>
									<div fxFlex="grow">21 Sep, 2020</div>
								</div>
								<div class="ui divider"></div>

									<div fxLayout="row">
									<div fxFlex="40%"><strong>Status</strong></div>
									<div fxFlex="grow"><label class="ui green circular label">Active</label></div>
								</div>
								<div class="ui divider"></div>

						</div>

				</div>
			</div>

</div>
